import classes from './Footer.module.scss';

import { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// Components
import Icon from 'components/Icon';
import Disclaimer from './Disclaimer';

const Footer:FC = () => {
  const { pathname } = useLocation();

  return (
    <footer className={classes.root}>
      <div className={`container ${classes.container}`}>
        <div className={classes.copy}>
          &copy; 2019–{new Date().getFullYear()} MouseOver.&nbsp;
          <span>All rights reserved.</span>
        </div>
        <div className={classes.links}>
          <NavLink to="/privacy-policy" className={classes.link}>Privacy Policy</NavLink>
          <NavLink to="/terms-of-service" className={classes.link}>Terms of Service</NavLink>
          {pathname !== '/office' && (
            <NavLink to="/office" className={classes.link}>Our Office</NavLink>
          )}
        </div>
        <a title='Our Linked.in page' className={classes.link} href="https://www.linkedin.com/company/mouse-over" target="_blank" rel="noreferrer">
          <Icon icon="LinkedIn" />
        </a>
      </div>
      <Disclaimer />
    </footer>
  )
}

export default Footer;
